import { useState, useEffect } from 'react';
import { Wheel } from 'react-custom-roulette';
import dateNightIdeas from '../data/dateNightIdeas.json';
import DateNight from './DateNightSpinner';
import { Link } from 'react-router-dom';
const Admin = () => {
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [locked, setLocked] = useState(true);
    const [filteredIdeas, setFilteredIdeas] = useState(dateNightIdeas);
  
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleLogin = () => {
        const adminPassword = 'Love Lobster';

        if (password === adminPassword) {
            setMessage('Login successful!');
            setLocked(false);
            localStorage.setItem("admin", "true");
        } else {
            setMessage('Incorrect password. Please try again.');
        }
    };

    useEffect(() => {
        // filterIdeas();
        let signedIn = localStorage.getItem("admin");

        if (signedIn == "true") {
            setLocked(false);
        }
        console.log("signedIn: ", signedIn)
        console.log("locked: ", locked)
    }, []);


    const data = filteredIdeas.map((idea, index) => ({
        option: idea.idea,
        image: {
            uri: '/coffee.png',
            offsetX: 5, // Optional
            offsetY: 155,
             // Optional
            sizeMultiplier: 0.4, // Optional
            landscape: false // Optional
        },
        style: { 
            // backgroundColor: index % 2 === 0 ? 'white' : '#ADD8E6',
            // backgroundColor: ['grey', 'lightblue', 'lightgreen', 'lightpink'],
            textAlign: 'center',
            wordWrap: 'break-word',
            padding: '5px',
            fontSize: '15',
        }
    }));

    return (
        <div style={{backgroundImage: 'url(/bgnd.png)' ,backgroundColor: 'rgb(122,147, 88)', height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', flexDirection: 'column',   backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover'
          }}>
            {locked && 
                
                <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <p>Admin Password:</p>
                    <input type="password" value={password} onChange={handlePasswordChange} />
                    <button onClick={handleLogin} style={{ margin: '1em' }}>Login</button>
                    {message && <p>{message}</p>}
                </div>

            } 
            {!locked &&
                <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', flexDirection: 'row', paddingInline: '20vw' }}>
                    <button style={styles.button} as={Link} to="./spinner">
                    <Link to="spinner" style={{ textDecoration: 'none', color: 'black' }}>
                        Date Night Ideas
                    </Link>
                    </button>
                    <button style={styles.button}>
                        <Link to="ll" style={{ textDecoration: 'none', color: 'black' }}>
                            My Love Letter to You
                        </Link>
                    </button>
                    <button style={styles.button}>
                        <Link to="countdowns" style={{ textDecoration: 'none', color: 'black' }}>
                            Countdowns
                        </Link>
                    </button>
                    <button style={styles.button}>
                        <Link to="mealplanner" style={{ textDecoration: 'none', color: 'black' }}>
                            Meal Planner
                        </Link>
                    </button>
                    <button style={styles.button}>
                        <Link to="../lovegame" style={{ textDecoration: 'none', color: 'black' }}>
                            Love Game 💕
                        </Link>
                    </button>
                </div>
                // <DateNight/>
            }
        </div>
        
        
    );
   
};

const styles = {
    
    button: {
        width: '10vw',
        height: '10vw',
        borderRadius: '0.5em',
        border: 'none',
        backgroundColor: 'rgba(240, 231, 217, 0.8)',
        fontSize: 'xx-large',

    },
  
};

export default Admin;